<template>
<div class="modal-view" :class="{ 'modal-view--covers-appbar': coversAppbar }">
  <div class="modal-mask" @click="dismissModal"></div>
  <div class="modal-container">
    <slot></slot>
  </div>
</div>
</template>

<script>
export default {
  props: ['protected', 'coversAppbar'],

  methods: {
    dismissModal() {
      if (this.protected && !confirm('Вы уверены, что хотите закрыть это окно?')) {
        return
      }

      this.$emit('dismiss')
    },
  },
}
</script>

<style lang="less">
@import '~@/assets/less/components/modal-mask';

.modal-view {
  .modal-container {
    @apply fixed bottom-0 z-modal-container bg-white shadow overflow-y-auto;
    top: var(--header-height);
    bottom: var(--bottom-nav-bar-height);
    right: 0;
    max-width: calc(100vw - var(--sidebar-width));
    width: 620px;
  }

  &.slide-sidebar-modal-enter-active,
  &.slide-sidebar-modal-leave-active {
    @longest-transition-duration: 0.3s;
    // This element doesn't actually have transitioning properties.
    // This is so Vue doesn't skip this element's children's transitions.
    transition-duration: @longest-transition-duration;
    .modal-container {
      transition: transform @longest-transition-duration ease;
    }
    .modal-mask {
      transition: opacity @longest-transition-duration - 0.1s;
    }
  }
  &.slide-sidebar-modal-leave-active {
    .modal-mask {
      @apply pointer-events-none; // So the content behind the mask can be interacted with with no delay.
    }
  }
  &.slide-sidebar-modal-enter,
  &.slide-sidebar-modal-leave-to {
    .modal-container {
      transform: translateX(100%);
    }
    .modal-mask {
      @apply opacity-0;
    }
  }

  &--covers-appbar {
    .modal-container {
      @apply top-0 z-modal-container--covers-appbar; // override `top: var(--header-height);`
    }
  }
}
</style>
